import config from './config';

export const API_ROUTES = {
  users: {
    upsert: `${config.api.baseUrl}/users/upsert`,
    logout: `${config.api.baseUrl}/users/logout`,
    info: `${config.api.baseUrl}/users/info`,
    profile: {
      get: `${config.api.baseUrl}/users/profile`, // get a user's profile information
      create: `${config.api.baseUrl}/users/profile`, // create a profile for a user
      update: `${config.api.baseUrl}/users/profile`, // update a profile
    }
  },
  jobs: {
    create: `${config.api.baseUrl}/jobs`,  // create a job
    list: `${config.api.baseUrl}/jobs`,  // get all jobs
    update: (jobId) => `${config.api.baseUrl}/jobs/${jobId}`, // update a job
    delete: (jobId) => `${config.api.baseUrl}/jobs/${jobId}`, // delete a job
  },
  resumes: {
    create: `${config.api.baseUrl}/resumes`, // create a resume
    list: `${config.api.baseUrl}/resumes`, // get all resumes
    get: (id) => `${config.api.baseUrl}/resumes/${id}`, // get a resume
    delete: (id) => `${config.api.baseUrl}/resumes/${id}`, // delete a resume
    experience: (id) => `${config.api.baseUrl}/resumes/${id}/experience`, // get all experiences for a resume
    education: (id) => `${config.api.baseUrl}/resumes/${id}/education`, // get all education for a resume
    skills: (id) => `${config.api.baseUrl}/resumes/${id}/skills`, // get all skills for a resume
  },
  experience: {
    create: (id) => `${config.api.baseUrl}/resumes/${id}/experience`, // create an experience for a resume
    update: (id, experienceId) => `${config.api.baseUrl}/resumes/${id}/experience/${experienceId}`, // update an experience
    delete: (id, experienceId) => `${config.api.baseUrl}/resumes/${id}/experience/${experienceId}`, // delete an experience
  },
  education: {
    create: (id) => `${config.api.baseUrl}/resumes/${id}/education`, // create an education for a resume
    update: (id, educationId) => `${config.api.baseUrl}/resumes/${id}/education/${educationId}`, // update an education
    delete: (id, educationId) => `${config.api.baseUrl}/resumes/${id}/education/${educationId}`, // delete an education
  },
  skills: {
    create: (id) => `${config.api.baseUrl}/resumes/${id}/skills`, // create a skill for a resume
    update: (id, skillId) => `${config.api.baseUrl}/resumes/${id}/skills/${skillId}`, // update a skill
    delete: (id, skillId) => `${config.api.baseUrl}/resumes/${id}/skills/${skillId}`, // delete a skill
  }
};
